import { render, staticRenderFns } from "./ProviderPortal.vue?vue&type=template&id=7dd240fd&scoped=true&"
import script from "./ProviderPortal.vue?vue&type=script&lang=js&"
export * from "./ProviderPortal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPortal.vue?vue&type=style&index=0&id=7dd240fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd240fd",
  null
  
)

export default component.exports